// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_home_home_module_ts":"15d98c2e2930de59","default-src_app_core_services_pedido-success-state_service_ts-src_app_core_services_pedidos_s-7e1e59":"0f5da97543626661","src_app_shop_shop_module_ts":"a5f625fe81b0d5ca","src_app_pages_pages_module_ts":"68d68e580e40c87f"}[chunkId] + ".js";
};